export const everythingSelectedOther = "wsh0b";
export default {everythingSelectedOther};